import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { ActionCard } from './ActionCard';

/**
 * @description Примеры использования ActionCard компонента
 */
export const ActionCardExamples: FC = () => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-2xl font-bold text-white mb-6">ActionCard Examples</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-lg font-semibold text-white">Platform Install App Example</h3>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-4">{t1}<div className="max-w-sm"><ActionCard id={1} type="platform" actionTypeName="platform_install_app" title="Install App and Get a Reward" backgroundImage="/images/actions/platform-install-bg.jpg" buttonText="install_app" tokenReward={500} gemReward={190} timeLeft={new Date(Date.now() + 86400000)} onButtonClick={_temp} /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="text-lg font-semibold text-white">Platform Install App with Placeholder</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-4">{t3}<div className="max-w-sm"><ActionCard id={2} type="platform" actionTypeName="platform_install_app" title="Install App - No Background Image" buttonText="install_app" tokenReward={300} gemReward={150} timeLeft={new Date(Date.now() + 43200000)} onButtonClick={_temp2} /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="text-lg font-semibold text-white">Regular Platform Example</h3>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="space-y-4">{t5}<div className="max-w-sm"><ActionCard id={3} type="platform" title="Platform Action" backgroundImage="/images/actions/platform-bg.jpg" buttonText="take_part" tokenReward={300} gemReward={150} timeLeft={new Date(Date.now() + 43200000)} onButtonClick={_temp3} /></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h3 className="text-lg font-semibold text-white">Quiz Example</h3>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="space-y-4">{t7}<div className="max-w-sm"><ActionCard id={3} type="quiz" title="Quiz Challenge" backgroundImage="/images/actions/quiz-bg.jpg" buttonText="start_quiz" tokenReward={200} gemReward={100} timeLeft={new Date(Date.now() + 21600000)} onButtonClick={_temp4} /></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h3 className="text-lg font-semibold text-white">Add Solana Address Example</h3>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="space-y-4">{t9}<div className="max-w-sm"><ActionCard id={4} type="platform" actionTypeName="platform_add_solana_address" title="Add Your Solana Address" backgroundImage="/images/actions/solana-bg.jpg" buttonText="add_solana_address" tokenReward={100} gemReward={50} timeLeft={new Date(Date.now() + 172800000)} onButtonClick={_temp5} /></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h3 className="text-lg font-semibold text-white">Register Example</h3>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="space-y-4">{t11}<div className="max-w-sm"><ActionCard id={5} type="platform" actionTypeName="platform_register" title="Register on Platform" backgroundImage="/images/actions/register-bg.jpg" buttonText="register" tokenReward={250} gemReward={125} timeLeft={new Date(Date.now() + 259200000)} onButtonClick={_temp6} /></div></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <h3 className="text-lg font-semibold text-white">Buy It Now Example</h3>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="space-y-4">{t13}<div className="max-w-sm"><ActionCard id={6} type="platform" actionTypeName="platform_ee_buy_it_now" title="Buy It Now Action" backgroundImage="/images/actions/buy-now-bg.jpg" buttonText="buy_it_now" tokenReward={400} gemReward={200} timeLeft={new Date(Date.now() + 43200000)} onButtonClick={_temp7} /></div></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h3 className="text-lg font-semibold text-white">Auction Bid Example</h3>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="space-y-4">{t15}<div className="max-w-sm"><ActionCard id={7} type="platform" actionTypeName="platform_ee_auction_bid" title="Place Auction Bid" backgroundImage="/images/actions/auction-bg.jpg" buttonText="auction_bid" tokenReward={300} gemReward={150} timeLeft={new Date(Date.now() + 129600000)} onButtonClick={_temp8} /></div></div>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h3 className="text-lg font-semibold text-white">Admin Coins Grant Example</h3>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="space-y-4">{t17}<div className="max-w-sm"><ActionCard id={8} type="platform" actionTypeName="platform_admin_coins_grant" title="Admin Coins Grant" backgroundImage="/images/actions/admin-grant-bg.jpg" buttonText="admin_coins_grant" tokenReward={1000} gemReward={500} timeLeft={new Date(Date.now() + 604800000)} onButtonClick={_temp9} /></div></div>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h3 className="text-lg font-semibold text-white">Referral Purchase Example</h3>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="space-y-4">{t19}<div className="max-w-sm"><ActionCard id={9} type="platform" actionTypeName="platform_referral_purchase" title="Referral Purchase Action" backgroundImage="/images/actions/referral-purchase-bg.jpg" buttonText="referral_purchase" tokenReward={600} gemReward={300} timeLeft={new Date(Date.now() + 345600000)} onButtonClick={_temp10} /></div></div>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h3 className="text-lg font-semibold text-white">Competition First Visit Example</h3>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="space-y-4">{t21}<div className="max-w-sm"><ActionCard id={10} type="platform" actionTypeName="platform_competition_first_visit" title="Competition First Visit" backgroundImage="/images/actions/competition-visit-bg.jpg" buttonText="competition_first_visit" tokenReward={150} gemReward={75} timeLeft={new Date(Date.now() + 64800000)} onButtonClick={_temp11} /></div></div>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <h3 className="text-lg font-semibold text-white">Referral Registration Example</h3>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="space-y-4">{t23}<div className="max-w-sm"><ActionCard id={11} type="platform" actionTypeName="platform_referral_registration" title="Referral Registration" backgroundImage="/images/actions/referral-registration-bg.jpg" buttonText="referral_registration" tokenReward={800} gemReward={400} timeLeft={new Date(Date.now() + 432000000)} onButtonClick={_temp12} /></div></div>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <h3 className="text-lg font-semibold text-white">Coins Purchase Example</h3>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="space-y-4">{t25}<div className="max-w-sm"><ActionCard id={12} type="platform" actionTypeName="platform_coins_purchase" title="Coins Purchase Action" backgroundImage="/images/actions/coins-purchase-bg.jpg" buttonText="coins_purchase" tokenReward={700} gemReward={350} timeLeft={new Date(Date.now() + 216000000)} onButtonClick={_temp13} /></div></div>;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <h3 className="text-lg font-semibold text-white">Gold Status Purchase Example</h3>;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="space-y-4">{t27}<div className="max-w-sm"><ActionCard id={13} type="platform" actionTypeName="platform_gold_status_purchase" title="Gold Status Purchase" backgroundImage="/images/actions/gold-status-bg.jpg" buttonText="gold_status_purchase" tokenReward={1200} gemReward={600} timeLeft={new Date(Date.now() + 864000000)} onButtonClick={_temp14} /></div></div>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <h3 className="text-lg font-semibold text-white">Bind Social Media Example</h3>;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="p-8 space-y-8">{t0}{t2}{t4}{t6}{t8}{t10}{t12}{t14}{t16}{t18}{t20}{t22}{t24}{t26}{t28}<div className="space-y-4">{t29}<div className="max-w-sm"><ActionCard id={14} type="platform" actionTypeName="platform_bind_social_media" title="Bind Social Media" backgroundImage="/images/actions/social-media-bg.jpg" buttonText="bind_social_media" tokenReward={350} gemReward={175} timeLeft={new Date(Date.now() + 108000000)} onButtonClick={_temp15} /></div></div></div>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  return t30;
};
export default ActionCardExamples;
function _temp() {
  return console.log("Install app clicked");
}
function _temp2() {
  return console.log("Install app with placeholder clicked");
}
function _temp3() {
  return console.log("Platform action clicked");
}
function _temp4() {
  return console.log("Quiz clicked");
}
function _temp5() {
  return console.log("Add Solana address clicked");
}
function _temp6() {
  return console.log("Register clicked");
}
function _temp7() {
  return console.log("Buy it now clicked");
}
function _temp8() {
  return console.log("Auction bid clicked");
}
function _temp9() {
  return console.log("Admin coins grant clicked");
}
function _temp10() {
  return console.log("Referral purchase clicked");
}
function _temp11() {
  return console.log("Competition first visit clicked");
}
function _temp12() {
  return console.log("Referral registration clicked");
}
function _temp13() {
  return console.log("Coins purchase clicked");
}
function _temp14() {
  return console.log("Gold status purchase clicked");
}
function _temp15() {
  return console.log("Bind social media clicked");
}